// import Swiper from 'swiper';
// import Utils from './util/utils';
// import 'jquery';

const TerminalMap = {
    
    init() {
        // JavaScript to be fired on the home page
        this._jMapWrapper = $('.map-container');
        this._addEvents();
        this.finalize();
    },
    
    
    finalize() {
        
        let me = this;
        
        // setTimeout(function() {
            me.initMap();
        // }, 5000);
    },
   
    
    initMap() {
        // alert('init');
     var data =  JSON.stringify(window.GLOBAL_TERMINAL);
     const parsedJson = JSON.parse(data);
    //  console.log(parsedJson);

    // var data  = JSON.stringify(window.GLOBAL_TERMINAL);  
      var map =  $('#terminalmapplic').mapplic({
            source: parsedJson,
            sidebar: false,
            toggle: true,
            alphabetic: true,
            height: 800,
            developer: false ,
            searchdescription: false,
            searcheverywhere: false,
            animations: true,
            hovertip: true,
            minimap: false,
            marker: 'hidden',
            fillcolor: false,
            fullscreen: true,
            thumbholder: true,
            maxscale:5,
            lightbox: true,
            zoombuttons:true,
            smartip:true,
            zoomoutclose:true,
            mousewheel:true,
            closezoomout:true,
           
        });
        var self = map.data('mapplic');
      
       
      
        $('.map-dropdown__item').on('click', function(e) {
            e.preventDefault();
            $('.map-dropdown__item').removeClass('active');
            var id = $(this).attr('data-location');
            $(this).addClass('active');
            self.showLocation(id);
         
        });

       
        map.on('mapready', function(e,self) {
            if ($('.page_map_harbourfront-passenger-terminal').length > 0) {
                self.moveTo(0.5,0.35,self.scale+(self.scale*0.5),600);
            }
            else{
                self.moveTo(0.55,0.6,self.scale+(self.scale*0.5),600);
            }
        });

        $('.map-dropdown__list_sm').on('change', function(e) {
            e.preventDefault();
            self.showLocation(this.value);
         
        });


        if ($('.page_map_harbourfront-passenger-terminal').length > 0) {
            $(document).ready(function() {
                var buttonLink = $('.mapplic-selected');
                var OptionLink = $('.selected-option');
                var bID = buttonLink.attr('data-level');
                var oID = OptionLink.attr('value');
                // alert(bID);
                // alert(oID);
                self.switchLevel(bID);
                self.switchLevel(oID);
            });
            $(window).load(function() {

                var buttonLink = $('.mapplic-selected');
                var OptionLink = $('.selected-option');
                var bID = buttonLink.attr('data-level');
                var oID = OptionLink.attr('value');
                // alert(bID);
                // alert(oID);
                self.switchLevel(bID);
                self.switchLevel(oID);
           });
             
        }
        
      
    },
    _addEvents() {
        
        if ($('#terminalmapplic').length > 0) {
            var headerHeight = $('.header').height();
            $('.terminal-mapdemo').css('bottom',headerHeight- 50);

            if (window.location.href.indexOf('feature') > -1) {
                $('html, body').delay(800).animate({
                   
                    scrollTop: $('.terminal-mapdemo').offset().top ,
                }, 800);
                          
              

              }

            }
        
    },
   
    
};

export default TerminalMap;


// WEBPACK FOOTER //
// ./scripts/modules/terminal.js